import api from "../services/api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export async function registerPush(authToken, options = {}) {
  if (typeof window === "undefined")
    return { success: false, reason: "NO_WINDOW" };
  if (
    !("serviceWorker" in navigator) ||
    !("PushManager" in window) ||
    !("Notification" in window)
  ) {
    return { success: false, reason: "NOT_SUPPORTED" };
  }

  try {
    const headers = {};
    if (authToken) headers.Authorization = `Bearer ${authToken}`;

    const registration = await navigator.serviceWorker.register("/sw.js", {
      scope: "/",
    });

    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      return { success: false, reason: "PERMISSION_DENIED" };
    }

    let vapidPublicKey = null;
    try {
      console.log("🔍 Fetching VAPID public key from backend...");
      const keyResponse = await api.get("/push/public-key", { headers });
      vapidPublicKey = keyResponse.data?.publicKey || null;
      console.log("✅ VAPID Key received:", vapidPublicKey ? "Yes" : "No");
    } catch (keyError) {
      console.warn("⚠️ Failed to fetch VAPID key from API, checking local environment:", keyError.message);
      vapidPublicKey = process.env.REACT_APP_VAPID_PUBLIC_KEY || null;
    }

    if (!vapidPublicKey) {
      console.error("❌ No VAPID public key found! Push will fail.");
      return { success: false, reason: "NO_VAPID_KEY" };
    }

    const applicationServerKey = urlBase64ToUint8Array(vapidPublicKey);

    // Get current subscription
    let subscription = await registration.pushManager.getSubscription();
    console.log("📡 Current push subscription:", subscription ? "Found" : "None");

    if (subscription && options.forceRefresh) {
      console.log("🔄 Force refreshing push subscription...");
      try {
        await subscription.unsubscribe();
        subscription = null;
      } catch (unsubscribeError) {
        console.warn("Unsubscribe failed:", unsubscribeError.message);
      }
    }

    if (!subscription) {
      console.log("✨ Creating new push subscription...");
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey,
      });
      console.log("✅ New subscription created");
    }

    const payload = {
      ...(subscription.toJSON ? subscription.toJSON() : subscription),
      guestId: options.guestId
    };

    console.log("📤 Sending subscription to backend...");
    await api.post("/push/subscribe", payload, { headers });
    console.log("🎉 Push subscription successfully saved to backend");

    return {
      success: true,
      subscription: subscription.toJSON ? subscription.toJSON() : subscription,
    };
  } catch (err) {
    console.error("⛔ Push registration error:", err.message);
    return { success: false, error: err.message };
  }
}
